<div
  *ngIf="showRunningBanner || showEndedBanner"
  class="w-full flex items-center justify-between gap-4 xs:px-5 md:px-14 py-2.5"
  [ngClass]="[
    topOffsetClass,
    showEndedBanner
      ? 'bg-Successful_text_colour'
      : 'bg-white border-b border-card_Bg_Color shadow-sm'
  ]"
>
  <div class="text-left">
    <p
      class="poppinsSemibold xs:text-sm md:text-base"
      [ngClass]="showEndedBanner ? 'text-white' : 'text-primary_Text_Color'"
    >
      Fetching your IQIGAI Buddy completion status
    </p>
    <p
      class="xs:text-xs 2xl:text-sm mt-0.5"
      [ngClass]="showEndedBanner ? 'text-white/80' : 'text-inactive_status_text'"
    >
      Please check your completion status in your profile under the IQIGAI
      Buddy section.
    </p>
  </div>

  <div *ngIf="showRunningBanner" class="text-right whitespace-nowrap">
    <p class="xs:text-xs md:text-sm text-inactive_status_text">
      Time Remaining
    </p>
    <p
      class="poppinsSemibold xs:text-sm md:text-base text-primary_Text_Color mt-0.5"
    >
      {{ profileTimer.formattedTime }} sec
    </p>
  </div>

  <button
    *ngIf="showEndedBanner"
    type="button"
    (click)="viewUpdatedProfile()"
    class="bg-white text-primary_Text_Color poppinsMedium xs:text-xs md:text-sm px-5 py-2.5 rounded-lg whitespace-nowrap shadow-sm"
  >
    View Updated Profile
  </button>
</div>
